import { render, staticRenderFns } from "./step1_detail.vue?vue&type=template&id=48d7572e"
import script from "./step1_detail.vue?vue&type=script&lang=js"
export * from "./step1_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports